import { TrendingUp } from 'lucide-react';
import { useEffect, type FC } from 'react';
import MarketingKPICards from './components/MarketingKPICards';
import { GuidedTour } from '@/components/onboarding/GuidedTour';
import { usePageTour } from '@/hooks/usePageTour';
import { marketingDashboardTourSteps } from '@/lib/tour-data';
import ContentPerformanceChart from './components/ContentPerformanceChart';
import ProspectPipelineTable from './components/ProspectPipelineTable';
import ReferralWidget from './components/ReferralWidget';

const TOUR_ID = 'admin-marketing-dashboard';

const MarketingDashboardPage: FC = () => {
  const tour = usePageTour(TOUR_ID);

  useEffect(() => {
    const handler = () => tour.startTour();
    window.addEventListener('restart-page-tour', handler);
    return () => window.removeEventListener('restart-page-tour', handler);
  }, [tour]);

  return (
    <div className="space-y-6">
      {/* Header gradient */}
      <div
        className="fc-gradient-header rounded-2xl p-6 text-white"
        style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1)' }}
      >
        <div className="flex items-center gap-3" data-tour="marketing-dashboard-header">
          <TrendingUp className="h-6 w-6" />
          <div>
            <h1 className="text-xl font-bold">Marketing Dashboard</h1>
            <p className="mt-0.5 text-xs italic text-blue-200">Tableau de bord marketing</p>
            <p className="mt-1 text-sm text-blue-100">
              Pilotage Growth &amp; Marketing — Feedback Orchestrator
            </p>
          </div>
        </div>
      </div>

      {/* KPIs */}
      <MarketingKPICards />

      {/* Graphique + Widget Referral (2/3 + 1/3) */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ContentPerformanceChart />
        </div>
        <ReferralWidget />
      </div>

      {/* Tableau Pipeline Prospects */}
      <ProspectPipelineTable />
      <GuidedTour tourId={TOUR_ID} steps={marketingDashboardTourSteps} isActive={tour.isActive} onComplete={tour.completeTour} onSkip={tour.skipTour} />
    </div>
  );
};

export default MarketingDashboardPage;
